import * as React from 'react';
import { useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { connect } from '@cian/adfox-component';

import { bannerWrapper } from '../../components/TGBanner/TGBannerEmpty';
import { IParseAdfoxItem } from './parseAdfox';

/**
 * Рендерит баннеры Adfox
 */
export const useContentAdfoxBanners = (extractedAdfoxItems: Pick<IParseAdfoxItem, 'data'>[]) => {
  useEffect(() => {
    extractedAdfoxItems.forEach(banner => {
      const { ownerId, containerId, params } = banner.data;
      const Component = connect(bannerWrapper(() => null));
      const container = document.getElementById(containerId);

      if (container) {
        createRoot(container).render(
          <Component ownerId={ownerId} params={params} width="100%" height="0" />,
        );
      }
    });
  }, [extractedAdfoxItems]);
};
